import Vue from 'vue'
import store from '~/store'
import router from '~/router/index_secondary'
import AppSecondary from '~/components/AppSecondary'
import { i18n } from '~/plugins/i18n'
import Notifications from 'vue-notification'
import VueMask from 'v-mask'
import VueLocalStorage from 'vue-localstorage'

import '~/plugins'
import '~/filters'
import '~/components'

Vue.config.productionTip = false

Vue.use(Notifications)
Vue.use(VueMask)
Vue.use(VueLocalStorage)

new Vue({
  i18n,
  store,
  router,
  ...AppSecondary
})
